var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4607_29267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26352 0C13.5852 0 17.0886 3.35786 17.0886 7.5C17.0886 11.6421 13.5852 15 9.26352 15C4.94186 15 1.43848 11.6421 1.43848 7.5C1.43848 3.35786 4.94186 0 9.26352 0ZM14.2306 10.4075V4.83334L11.3226 7.62038L14.2306 10.4075ZM4.91768 10.521H13.6095L10.9531 7.97487L9.9406 8.94513C9.89151 8.99205 9.825 9.01839 9.75567 9.01837H8.77143C8.73709 9.0184 8.70308 9.01195 8.67134 8.99938C8.63961 8.98681 8.61077 8.96838 8.58647 8.94513L7.57404 7.97487L4.91756 10.521H4.91768ZM4.29645 4.83316V10.4076L7.20446 7.62038L4.29645 4.83316ZM13.8609 4.47899H4.66631L8.87972 8.51739H9.64746L13.8609 4.47899Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4607_29267"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.303223,
    width: 17.4107,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.efc16935e9346fc1199901a421120c3f.svg";
export { ForwardRef as ReactComponent };